import { Dispatch, SetStateAction, useCallback } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContactForm from "@shared/components/ContactForm";

interface Props {
  modalVisible: string;
  setModalVisible: Dispatch<SetStateAction<string>>;
}

const TITLE_ID = "contact-modal-title";

const ContactModal = ({ modalVisible, setModalVisible }: Props) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const handleClose = useCallback(() => {
    setModalVisible("");
  }, [setModalVisible]);

  return (
    <Dialog
      open={modalVisible === "contact"}
      onClose={handleClose}
      fullScreen={fullScreen}
      fullWidth
      // sm rather than xs: the multiline message field benefits from
      // a slightly wider container than the auth modals.
      maxWidth="sm"
      aria-labelledby={TITLE_ID}
      PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 2 } }}
    >
      <DialogTitle
        id={TITLE_ID}
        component="h2"
        sx={{
          pr: 6,
          fontSize: { xs: "1.25rem", sm: "1.375rem" },
          fontWeight: 600,
        }}
      >
        Contact us
      </DialogTitle>
      <IconButton
        aria-label="Close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (t) => t.palette.text.secondary,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ pt: 1 }}>
        <ContactForm onSent={handleClose} />
      </DialogContent>
    </Dialog>
  );
};

export default ContactModal;
